import { setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import * as styleguide from "@tSurya/theme/styleguide";

const _styleguide = styleguide as any;

setPreStyleGuideTheme(_styleguide); // Change to 'setPreStyleGuideTheme' as needed
